































































































































import { VNode } from 'vue';
import _debounce from 'lodash/debounce';
import { Subject } from 'rxjs';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { TopNavItem, MyClientRect, HighlightReferrerInfo, ProvidedTopNavParam } from './types';
import SwTopNavItem from './sw-top-nav-item.vue';
import SwNavSideIndicator from './sw-nav-side-indicator.vue';
import { utilService } from '../util-service';
import { SwDropMenu, DropMenuItem } from '../sw-drop-menu';
import { SwIcon, IconConfig } from '../sw-icon';
import { SwIconTabDivider } from '../sw-icon-tab';

const cssPrefix = 'sw-top-nav';

/**
 * Events:
 * @event select `(itemId: string)`
 */
@Component({
  components: {
    SwTopNavItem,
    SwNavSideIndicator,
    SwDropMenu,
    SwIcon,
    SwIconTabDivider,
  },
})
export default class SwTopNav extends SwExtendedVue {
  @Prop({ type: Array, required: true })
  items: TopNavItem[];

  @Prop({ type: String, required: true })
  selected: string;

  @Prop({ type: String, default: 'expand' })
  mode: 'expand' | 'dropdown';

  @Provide()
  navParam: ProvidedTopNavParam = {
    eventbus: new Subject(),
    mode: this.mode,
  };

  cssPrefix =  cssPrefix;
  isDim: boolean = false;
  highlightReferrer: HighlightReferrerInfo | null = null;

  dropMenuOpened: boolean = false;

  get indicatorColor() {
    return utilService.colorConst.selected;
  }

  get selectedItem(): TopNavItem | null {
    const item = this.items.find(i => (i.id === this.selected));
    return item || null;
  }

  get dropMenuItems(): DropMenuItem[] {
    const navItemsInDropdown = this.items.filter(i => (!this.selectedItem || i.id !== this.selectedItem.id));
    return navItemsInDropdown.map<DropMenuItem>((item) => {
      if (item.divider === true) {
        return { id: item.id, divider: true };
      }
      return {
        id: item.id,
        content: (h): VNode => {// tslint:disable-line
          const iconConfig: IconConfig = Object.assign({}, item.icon, { size: 18 });
          return (
            <div class={[`${cssPrefix}__drop-item-cont`, 'sw-flexbox', 'sw-flexbox--center-items']}>
              <SwIcon {...{
                props: iconConfig,
                class: ['sw-flexbox__flex-none'],
              }} />
              <span class={[`${cssPrefix}__drop-item-label`, 'sw-flexbox__flex']}>{ item.label }</span>
            </div>
          ) as VNode;
        },
        clickable: true,
        disabled: item.disabled === true,
      };
    });
  }

  get showIndicator() {
    return this.mode === 'expand' || !this.dropMenuOpened;
  }

  @Provide()
  private claimSelectNavItem(itemId: string) {
    this.$emit('select', itemId);
  }

  @Provide()
  private claimHighlightReferrer(itemId: string, boundingRect: MyClientRect) {
    this.highlightReferrer = {
      boundingRect,
      navId: itemId,
    };
  }

  @Provide()
  public claimCheckHighlightReferrerRequest() {
    this.$nextTick(() => {
      this.navParam.eventbus.next('request-check-highlight-referrer');
    });
  }

  @Watch('mode')
  private onModeChange() {
    this.navParam.mode = this.mode;
    this.$nextTick(() => {
      this.claimCheckHighlightReferrerRequest();
    });
  }

  get delayedDim() {
    return _debounce(
      () => { this.isDim = true; },
      6000,
    );
  }

  private onMouseEnter() {
    this.isDim = false;
    this.delayedDim.cancel();
  }

  private onMouseLeave() {
    this.delayedDim();
  }

  private onSelectDropMenuItem(itemId: string) {
    this.claimSelectNavItem(itemId);
    this.dropMenuOpened = false;
  }

  private onClickDropTrigger() {
    this.dropMenuOpened = !this.dropMenuOpened;
  }

  private mounted() {
    this.delayedDim();
    this.$nextTick(() => {
      /** wait a short interval before re-request check highlight in order that everything is stable */
      setTimeout(() => { this.claimCheckHighlightReferrerRequest(); }, 300);
    });
  }
}
